import { Outlet, useNavigation } from "react-router";

import { Header } from "./header";
import { Sidebar } from "./sidebar";

/** Barra fina arriba mientras se carga una zona (los trozos van con `lazy`). */
export const NavigationProgress = () => {
  const navigation = useNavigation();
  if (navigation.state === "idle") return null;
  return (
    <div
      className="fixed inset-x-0 top-0 z-50 h-0.5 animate-pulse bg-foreground"
      role="progressbar"
      aria-hidden
    />
  );
};

/** Shell de la app con sesión: barra lateral, cabecera y la pantalla. */
export const AppShell = () => (
  <div className="flex min-h-screen w-full bg-background">
    <NavigationProgress />
    <Sidebar />
    <div className="flex min-w-0 flex-1 flex-col">
      <Header />
      <main className="flex-1 bg-muted-subtle">
        <Outlet />
      </main>
    </div>
  </div>
);
